export default theme => ({
  root: {
    maxWidth: "100%",
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(2),
    paddingRight: theme.spacing(3),
    paddingLeft: theme.spacing(3)
  },
  divider: {
    backgroundColor: "#efefef"
  },
  title: {
    fontSize: "18px",
    lineHeight: "21px",
    textAlign: "center",
    marginTop: theme.spacing(2)
  },
  cardTasks: {
    marginTop: "5px",
    textAlign: "center"
  },
  listItem: {
    flexWrap: "wrap",
    minHeight: "60px",
    cursor: "pointer",
    borderTop: "1px solid #eee",
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),

    "&:hover": {
      background: theme.palette.background.light
    },
    [theme.breakpoints.up("sm")]: {
      flexWrap: "nowrap"
    }
  },
  leftContainer: {
    minWidth: "250px",
    flex: "1 1 100%",

    order: 4,
    [theme.breakpoints.up("sm")]: {
      order: 0,
      flexBasis: "auto"
    }
  },
  listItemTitle: {
    fontSize: "15px",
    lineHeight: "18px",
    fontWeight: 500,
    paddingBottom: theme.spacing(0.5),
    color: theme.palette.text.secondary
  },
  listItemSubtitle: {
    fontSize: "12px",
    lineHeight: "18px",
    color: "#9f9f9f"
  },
  actionIcon: {
    marginRight: theme.spacing(1)
  },
  spacer: {
    flexGrow: 1
  },
  rightContainer: {
    flex: "0 0 50px",
    order: 2,
    [theme.breakpoints.up("sm")]: {
      order: 0
    }
  },
  rightContainerInner: {
    display: "flex",
    alignItems: "center"
  },
  verticalDivider: {
    display: "none",
    background: "red",
    borderLeft: "1px solid #efefef",
    width: "1px",
    height: "100%",
    marginRight: "8px",
    [theme.breakpoints.up("sm")]: {
      display: "block"
    }
  },
  taskAvatar: {
    borderRadius: "0 !important",
    height: "inherit"
  },
  connectorName: {
    fontSize: "11px",
    fontWeight: 500,
    letterSpacing: "0.38px",
    color: "#9f9f9f",

    textOverflow: "ellipsis"
  },
  actionsIcon: {
    // width: "100px",
    display: "flex",
    alignContent: "center",
    marginLeft: "auto",
    order: 3,
    [theme.breakpoints.up("sm")]: {
      order: 0
    }
  },
  // GRID VIEW

  gridItem: {
    // display: "inline-block",
    width: "240px",
    height: "130px",
    padding: theme.spacing(1),

    display: "flex",
    alignContent: "flex-end",
    justifyContent: "space-between",
    flexWrap: "wrap",
    minHeight: "60px",
    cursor: "pointer"
  },
  gridItemPadding: {
    display: "flex",
    alignContent: "space-between",
    flexDirection: "column",

    height: "100%",
    width: "100%",
    padding: theme.spacing(1),
    // background: theme.palette.background.light,
    background: "white",
    border: "solid 1px #f6f6f6",
    boxShadow: "1px 1px 2px 0 rgba(0, 0, 0, 0.1)",

    "&:hover": {
      boxShadow: "3px 3px 6px 0 rgba(0, 0, 0, 0.1)"
    }
  },
  upContainer: {
    flexGrow: 1
  },
  downContainer: {
    width: "206px",
    display: "flex",
    alignItems: "center"
  },
  connectorNameGrid: {
    display: "block",
    fontSize: "11px",
    fontWeight: 500,
    letterSpacing: "0.38px",
    color: "#9f9f9f",

    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    width: "150px"
  }
});
